var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: {
            callback: _vm.handleScrollIntoView,
            once: true
          },
          expression:
            "{\n    callback: handleScrollIntoView,\n    once: true,\n  }"
        }
      ],
      key: _vm.tileUniqueId,
      class: [
        _vm.bemBlockMod({ "quick-shop-opened": _vm.quickShopOpened }),
        "product-tile",
        "product-detail",
        "product-detail-vue"
      ],
      attrs: {
        "data-key": _vm.tileUniqueId,
        "data-pid": _vm.product.id,
        "data-context": _vm.context,
        itemscope: "",
        itemtype: "http://schema.org/Product"
      },
      on: {
        mouseenter: function($event) {
          _vm.hover = true
        },
        mouseleave: function($event) {
          _vm.hover = false
        },
        mousedown: _vm.mousedownHandler,
        mousemove: _vm.mousemoveHandler
      }
    },
    [
      !_vm.hasPlpSliderBannerContext
        ? _c("BaseProductDataForSfra", { attrs: { product: _vm.product } })
        : _vm._e(),
      _vm._v(" "),
      _c("meta", { attrs: { itemprop: "sku", content: _vm.product.id } }),
      _vm._v(" "),
      _c("meta", { attrs: { itemprop: "mpn", content: _vm.product.id } }),
      _vm._v(" "),
      _vm.product.longDescription
        ? _c("meta", {
            attrs: {
              itemprop: "description",
              content: _vm.product.longDescription
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("meta", { attrs: { itemprop: "brand", content: "BIMBA Y LOLA" } }),
      _vm._v(" "),
      _c("BaseProductTileImage", {
        class: _vm.bemElement("image"),
        attrs: {
          "are-carousel-controls-shown": _vm.areCarouselControlsShown,
          context: _vm.context,
          "force-main-image-to-load": _vm.forceMainImageToLoad,
          "has-carousel": _vm.hasCarousel,
          product: _vm.product,
          url: _vm.url
        },
        on: {
          click: _vm.viewProductDetails,
          "load-main-image": function($event) {
            return _vm.$emit("load-main-image", $event)
          }
        }
      }),
      _vm._v(" "),
      _vm.showIframeTag
        ? _c("BaseTag", {
            class: [_vm.bemElement("main-label"), "iframe-tag"],
            attrs: {
              product: _vm.product,
              type: "grid",
              subtype: "secondary",
              text: _vm.$msg("tag.iframe", "product"),
              "is-custom": true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.minimal
        ? _c(
            "div",
            { class: _vm.bemElement("body") },
            [
              _vm.secondaryTag
                ? _c("BaseTag", {
                    class: _vm.bemElement("main-label", "overlap"),
                    attrs: {
                      product: _vm.product,
                      type: "grid",
                      subtype: "secondary",
                      text: _vm.secondaryTag,
                      "text-color": _vm.secondaryTagColor,
                      "is-custom": _vm.isCustomTag
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.primaryTag
                ? _c("BaseTag", {
                    class: _vm.bemElement("main-label"),
                    attrs: {
                      product: _vm.product,
                      type: "grid",
                      subtype: "primary",
                      text: _vm.primaryTag
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideProductNames
                ? _c("BaseProductTileName", {
                    class: _vm.bemElement("name"),
                    attrs: {
                      product: _vm.product,
                      url: _vm.url,
                      "line-clamp": _vm.tileNameLineClampNumber
                    },
                    on: { click: _vm.viewProductDetails }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.hidePrices && _vm.product.price
                ? _c("BasePrice", {
                    class: _vm.bemElement("price"),
                    attrs: {
                      product: _vm.product,
                      "show-previous-price-msg": _vm.showPreviousPriceMsg
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showQuickShop
                ? _c("BaseProductTileQuickShop", {
                    class: _vm.bemElement("quick-shop", {
                      opened: _vm.quickShopOpened
                    }),
                    attrs: { context: _vm.context, product: _vm.product },
                    on: {
                      open: function() {
                        return (_vm.quickShopOpened = true)
                      },
                      close: function() {
                        return (_vm.quickShopOpened = false)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFullTileQuickShop
        ? _c("BaseProductTileQuickShop", {
            class: _vm.bemElement("quick-shop", {
              opened: _vm.quickShopOpened
            }),
            attrs: { context: _vm.context, product: _vm.product },
            on: {
              open: function() {
                return (_vm.quickShopOpened = true)
              },
              close: function() {
                return (_vm.quickShopOpened = false)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSwatches
        ? _c("BaseProductColorSwatches", {
            class: _vm.bemElement("swatches"),
            attrs: {
              product: _vm.product,
              "show-current": true,
              "pre-expanded": _vm.product.preExpanded || false
            },
            on: { select: _vm.updateProductColorVariant }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }